require('./cardsBoxHeaderTravelPlusToggle.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const moment = require('moment');
const classNames = require('classnames');

// @ commons
const TextToggle = require('components/commons/textToggle/textToggle');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const CardR42TravelPlusModal = require('components/cards/cardR42TravelPlusModal/cardR42TravelPlusModal');

// @constants
const {
    R42_CARD_OFF,
    R42_CARD_ON,
    R42_CARD_PENDING_DEACTIVATION,
    R42_CARD_VIP,
} = require('constants/cardR42States');
const {
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
} = require('constants/index');

class CardsBoxHeaderTravelPlusToggle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.handleModalToggle = this.handleModalToggle.bind(this);
    }

    handleModalToggle() {
        const {
            immCard,
            immTravelPlus,
            setCardTravelPlus,
            travelPlusReset,
        } = this.props;

        if (this.state.showModal) {
            if (immTravelPlus.get('submitSuccessful')) {
                setCardTravelPlus(immCard.get('cardId'));
            }

            //Because when modal is closed has a 300ms animation
            setTimeout(() => {
                travelPlusReset();
            }, 300);
        }

        this.setState((prevState) => {
            let showModal = prevState.showModal;

            if (!immTravelPlus.get('isFetching')) {
                showModal = !showModal;
            }

            return {
                showModal,
            }
        });
    }

    buildModal(status, vip) {
        const {
            forceVipBehavior,
            hireTravelPlusCCWrapUpOffStart,
            hireTravelPlusCCWrapUpOnStart,
            immCard,
            immGlobalVariables,
            immSignaturePattern,
            immTravelPlus,
            setTravelPlus,
            descIntervenciones,
            travelSwitchVisible
        } = this.props;
        const subtypeCriteria = immCard.getIn(['criteria', 'c1', 'subtipoproducto']);
        const standCriteria = immCard.getIn(['criteria', 'c1', 'estand']);
        const productContract = immCard.getIn(['contract', 'product']);


        return (
            <CardR42TravelPlusModal
                forceVipBehavior={forceVipBehavior}
                hireTravelPlusCCWrapUpOffStart={hireTravelPlusCCWrapUpOffStart}
                hireTravelPlusCCWrapUpOnStart={hireTravelPlusCCWrapUpOnStart}
                immCard={immCard}
                immGlobalVariables={immGlobalVariables}
                immSignaturePattern={immSignaturePattern}
                immTravelPlus={immTravelPlus}
                isOpen={this.state.showModal}
                onCloseCallback={this.handleModalToggle}
                setTravelPlus={setTravelPlus}
                subtypeCriteria={subtypeCriteria}
                standCriteria={standCriteria}
                productContract={productContract}
                status={status}
                vip={vip}
                travelSwitchVisible={travelSwitchVisible}
                descIntervenciones={descIntervenciones}
            />
        );
    }
    render() {
        const {
            immCard,
            forceVipBehavior,
            showSwitchAlone,
            travelSwitchVisible,
            vip,
        } = this.props;
        const immCardTravelPlus = immCard.get('travelPlus');
        let checked = false;
        let partiallyUnchecked = false;
        let response = null;
        let errorText;

        if (!forceVipBehavior && immCardTravelPlus.get('isFetching')) {
            response = <LoadingSection />;
        } else {
            const status = immCardTravelPlus.get('status');
            let suscriptionSection;
            let suscriptionText;
            if (vip) {
                checked = true;
                suscriptionText = formatText('travelPlusCardToggle-travelPlusCardToggle_freeSuscription');
            } else {
                if (immCardTravelPlus.get('error')) {
                    checked = false;
                    const classNameSubErrorText = classNames('cards-box-header-travel-plus-toggle__error-text', {
                        'cards-box-header-travel-plus-toggle__error-text--align-left': showSwitchAlone,
                        'cards-box-header-travel-plus-toggle__error-text--align-right': !showSwitchAlone,
                    });
                    errorText = (
                        <FormattedText
                            className={classNameSubErrorText}
                            value="travelPlusCardToggle-travelPlusCardToggle_errorTravelSubText"
                        />
                    );
                } else {
                    switch (status) {
                        case R42_CARD_ON:
                            checked = true;
                            break;
                        case R42_CARD_PENDING_DEACTIVATION:
                            partiallyUnchecked = true;
                            const validDate = moment(immCardTravelPlus.get('validDate')).format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);
                            suscriptionText = formatText('travelPlusCardToggle-travelPlusCardToggle_partialSuscription', [validDate]);
                            break;
                        default:
                            checked = false;
                    }
                }
            }


            const modalContent = this.buildModal(status, vip);
            const toggle = (

                <TextToggle
                    checked={checked}
                    onClick={this.handleModalToggle}
                    partiallyUnchecked={partiallyUnchecked}
                    textCheck="ON"
                    textUncheck="OFF"

                />

            );
            if (showSwitchAlone) {
                response = (
                    <span className="cards-box-header-travel-plus-toggle">
                        {toggle}
                        {modalContent}
                        {errorText}
                    </span>
                );
            } else {
                if (!!suscriptionText) {

                    suscriptionSection = (
                        <span className="cards-box-header-travel-plus-toggle__suscription-active-text">
                            {suscriptionText}
                        </span>
                    );
                }

                if (travelSwitchVisible) {

                    response = (
                        <span className="cards-box-header-travel-plus-toggle">
                            <FormattedText
                                className="cards-box-header-travel-plus-toggle__description-container"
                                value="travelPlusCardToggle-travelPlusCardToggle_travelPlusTextLandingCards"
                            />
                            <div className="cards-box-header-travel-plus-toggle__wrapper-text-toggle">
                                {toggle}
                            </div>
                            {suscriptionSection}
                            {errorText}
                            {modalContent}
                        </span>
                    );
                }

            }
        }

        return response;
    }
}

CardsBoxHeaderTravelPlusToggle.propTypes = {
    forceVipBehavior: PropTypes.bool,
    hireTravelPlusCCWrapUpOffStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    setCardTravelPlus: PropTypes.func.isRequired,
    setTravelPlus: PropTypes.func.isRequired,
    showSwitchAlone: PropTypes.bool,
    travelPlusReset: PropTypes.func.isRequired,
};

CardsBoxHeaderTravelPlusToggle.defaultProps = {
    forceVipBehavior: false,
    showSwitchAlone: false,
};

module.exports = CardsBoxHeaderTravelPlusToggle;
